<template>
    <div>{{ row.week.number }}</div>
</template>

<script>
export default {
    props: ['row'],
};
</script>
